import { Box, Divider, Grid, Typography } from "@mui/material";
import Button from "components/ui/Button";
import React, { useEffect, useMemo, useState } from "react";
import { AllowIp } from "../utilis/AllowIp";
import { dyanamicIpData } from "../utilis/ipData";
import { IOSSwitch } from "features/Setting/My_Binnys_Access/IOSSwitch";
import { AddAllowIPModel } from "../utilis/AddAllowIPModel";
import RemoveModal from "components/ui/RemoveModal/RemoveModal";
import CalenderComp from "features/Setting/order/components/CalenderComp";

export const AllowIpFrom = ({ allowIp, setAllowIp, selectedDate, setSelectedDate, allowFullAccess, setAllowFullAccess }) => {
  const [alloweIpModel, setAlloweIPModel] = useState(false);
  const [removeIpModal, setRemoveIpModel] = useState(false);
  const [removeIpIndex, setRemoveIpIndex] = useState(null);
  const [showCalendar, setShowCalendar] = useState(false);

  const addAllowIPButton = () => {
    setAlloweIPModel(true);
  };

  const handleSetIp = ({ newIps }) => {
    setAllowIp((prev) => [
      ...prev,
      {
        from_ip: newIps?.from_ip,
        to_ip: newIps?.to_ip,
      },
    ]);
  };

  const handleDeleteSetIp = ({ indexId }) => {
    setRemoveIpIndex(indexId);
    setRemoveIpModel(true);
  };

  const handleDiscardRemoveIpChanges = () => {
    setRemoveIpModel(false);
    setRemoveIpIndex(null);
  };

  const modalRemoveIpBtnInfo = useMemo(
    () => [
      {
        btnName: "No",
        bgColor: "#E77B7B",
        click: handleDiscardRemoveIpChanges,
      },
      {
        btnName: "Yes",
        bgColor: "#50C878",
        click: () => {
          const updateData = allowIp.filter((ip, index) => index !== removeIpIndex);
          setAllowIp(updateData);
          handleDiscardRemoveIpChanges();
        },
      },
    ],
    [handleDiscardRemoveIpChanges, setAllowIp]
  );

  const openCalendar = () => setShowCalendar(true);

  const closeCalender = () => {
    if (!selectedDate || selectedDate === "") {
      setAllowFullAccess(false);
    } else {
      setAllowFullAccess(true);
    }
    setShowCalendar(false);
  };

  const handleDateSelect = (formattedDate) => {
    setSelectedDate(formattedDate);
  };

  return (
    <>
      <Grid
        container
        width={"63%"}
        rowGap="10px"
        sx={{
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
          border: "1px solid #191818",
          marginLeft: "25px",
          paddingRight: "0px",
          paddingLeft: "0px",
          paddingTop: "0px",
          paddingBottom: "0px",
          backgroundColor: "#191818",
        }}
      >
        <Grid width={"100%"} item xm={12} sm={12} md={10} lg={12} xl={12} sx={{ paddingTop: "20px", paddingLeft: "20px", paddingRight: "20px" }}>
          <Box sx={{ width: "100%", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <Typography sx={{ color: "#FFFFFF", fontFamily: "Poppins", fontSize: "24px", fontWeight: 500, lineHeight: "22px" }}>Allowed IP Addresses </Typography>
            <Button onClick={addAllowIPButton}>Add +</Button>
          </Box>
          <Divider orientation="horizontal" flexItem style={{ borderColor: "#444444", width: "100%", marginBottom: "10px", marginTop: "10px" }} />
        </Grid>
        <Grid width={"100%"} item xm={12} sm={12} md={12} lg={12} xl={12}>
          {allowIp &&
            allowIp.length > 0 &&
            allowIp.map((ip, index) => {
              return (
                <AllowIp
                  key={`allowIp-${ip.from_ip}-${ip.to_ip}-${index}`}
                  keyName={`allowIp-${index}`}
                  ipData={dyanamicIpData({ ip, index })}
                  isDeleteIcon={ip?.networkType === "Company" ? false : true}
                  dyanamicWidth={"110%"}
                  handleDelete={() => {
                    handleDeleteSetIp({ indexId: index });
                  }}
                />
              );
            })}
        </Grid>
        {allowIp && allowIp.length > 0 && (
          <Grid width={"100%"} item xm={12} sm={12} md={12} lg={12} xl={12} sx={{ paddingBottom: "20px", paddingLeft: "20px", paddingRight: "20px" }}>
            <Divider orientation="horizontal" flexItem style={{ borderColor: "#444444", width: "100%", marginBottom: "10px", marginTop: "10px" }} />
            <Box sx={{ backgroundColor: "#101010", padding: "10px", borderRadius: "5px", marginTop: "20px" }}>
              <Box sx={{ width: "100%", display: "flex", justifyContent: "flex-start", alignItems: "center", gap: "20px", marginBottom: "10px", marginTop: "10px", marginLeft: "10px" }}>
                <Typography sx={{ color: "#FFFFFF", fontFamily: "Poppins", fontSize: "24px", fontWeight: 500, lineHeight: "22px" }}>Allow Full Access</Typography>
                <IOSSwitch
                  // disabled={loader}
                  label=""
                  checked={allowFullAccess || selectedDate || false}
                  onChange={(e) => {
                    if (e.target.checked) {
                      setAllowFullAccess(e.target.checked);
                      openCalendar();
                    } else {
                      setAllowFullAccess(e.target.checked);
                      setSelectedDate(null);
                    }
                  }}
                  width="71px"
                  translatecheck="38px"
                  translateuncheck="6px"
                />
                {selectedDate && (
                  <Typography sx={{ color: "#FFFFFF", fontFamily: "Karla", fontSize: "18px", fontWeight: 500, lineHeight: "22px" }}>
                    {selectedDate} <span style={{ color: "#8B8B8B" }}>(Full access expires on)</span>
                  </Typography>
                )}
              </Box>
            </Box>
          </Grid>
        )}
      </Grid>

      <AddAllowIPModel open={alloweIpModel} setOpen={setAlloweIPModel} handleSetIp={handleSetIp} />
      <RemoveModal open={removeIpModal} setOpen={setRemoveIpModel} btnInfo={modalRemoveIpBtnInfo} heading="Are you sure you want to remove this IP address?" oneLiner={true} />
      <CalenderComp
        open={showCalendar}
        handleClose={closeCalender}
        onDateSelect={handleDateSelect}
        formatOnApply={true}
        allowAllDates={true}
        // setFormatedSelectedDate={setFormatedSelectedDate}
        // disableRestrictedDates
        style={{ mr: 0, width: "430px", height: "551px" }}
        privSelectedDate={selectedDate}
        rangeOfDate={{
          min: () => {
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            return today;
          },
          max: () => {
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            const sixMonthsLater = new Date(today);
            sixMonthsLater.setMonth(sixMonthsLater.getMonth() + 6); // add 6 months
            return sixMonthsLater;
          },
        }}
        content={{ topTitle: "Full access is temporary. Set a revoke date to revert to allowed IPs." }}
      />
    </>
  );
};
